export const CST_TIMEZONE = "America/Chicago";
export const DAY_AFTER_TOMORROW = "day-after-tomorrow";